<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-card
          max-width="600"
          elevation="0"
          rounded="xxl"
          color="background"
          data-testid="choose-new-password-card"
        > 
          <div v-if="isLoading">
            <v-progress-circular indeterminate />
            <p class="text-body-1">
              {{ $t('confirmAccountLoading') }}
            </p>
          </div>
          <v-card-title class="text-h5 font-weight-bold no-break">
            {{ $t('chooseaNewPassword') }}
          </v-card-title>
          <v-card-text>
            <AlertMessages
              v-if="alertValue"
              alert-type="error" 
              :alert-msg="alertMsg"
              @reset="alertValue = false"
            />

            <v-form
              ref="form"
              v-model="valid"
              @keyup.enter="sendNewPassword()"
              @submit.prevent
            >
              <v-text-field
                v-model="password"
                data-testid="password-input"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('chooseaNewPasswordPlaceholder')"
                :rules="passwordRules"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="confirmPassword"
                data-testid="password-confirm-input"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPasswordConfirm ? 'text' : 'password'"
                :placeholder="$t('chooseaNewConfirmPasswordPlaceholder')"
                :rules="passwordRules.concat(passwordConfirmationRule)"
                @click:append="showPasswordConfirm = !showPasswordConfirm"
              />
              <v-card-actions class="px-0">
                <v-btn
                  data-testid="redirect-button"
                  type="submit"
                  :disabled="buttonDisabled"
                  color="accent"
                  large
                  block
                  class="rounded-xxl text-none"
                  @click="sendNewPassword()"
                >
                  {{ $t('changePassword') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text> 
        </v-card>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import { ruleRequired, passwordRuleValid, passwordRuleCharactersValid } from '../../rules/formRules.js';
import i18n from '../../plugins/i18n';
import { resetPassword,tokenCheck } from '../../api/userApi';
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    data(){
        return{
            valid: true,
            password: '',
            confirmPassword: '',
            passwordRules: ruleRequired('labelPassword').concat(passwordRuleCharactersValid, passwordRuleValid),
            showPassword: false,
            showPasswordConfirm: false,
            alertType: '',
            alertMsg: '',
            alertValue : false,
            buttonDisabled: false,
            isLoading: false,
            email:''

        }
    },
     computed: {
        passwordConfirmationRule() {
            return () =>
                this.password === this.confirmPassword || i18n.t('fieldErrorMatch', {'field': i18n.t('labelPassword') })
        }
    },
     async created() {
        this.isLoading = true 
        try {
            let data = {
                token: this.$route.query.token,  
            };
            const response = await tokenCheck(data)
            if(response.status == 200) {
               this.email = response.data.meta.email;
               this.isLoading = false;
            }
        } catch (e) {
            this.error = true
            this.isLoading = false
            if(e.response){
                if(e.response.status == 401){
                    this.$router.push({name: 'Login', params: {passwordReset: false}})
                    this.alertMsg = i18n.t('serverError')
                    this.alertValue = true
                }
            }
        }
    },
    methods: {
        async sendNewPassword(){
            this.$refs.form.validate()
             if(this.valid){
                this.buttonDisabled = true
                if(this.$route.query){
                    try {
                    let data = {
                                email: this.email,
                                token: this.$route.query.token,
                                password: this.password,  
                                password_confirmation: this.confirmPassword
                    };

                    const response = await resetPassword(data)
                    if(response.status == 200) {
                     this.$router.push({name: 'Login', params: {passwordReset: true}})
                    }
                    this.$refs.form.reset()
                } catch (e) {
                    if(e.response){
                        this.alertValue = true 
                        if (e.response.status == 401) {
                            this.alertMsg =  i18n.t('serverError')
                        } else if(e.response.status == 403){
                            for (let i = 0; i < e.response.data.errors.length; i++) {
                                if (e.response.data.errors[i].detail == 'You must log in using SSO') {
                                    this.alertMsg = i18n.t('mustLogInUsingSSO')
                                }
                            }
                        }else if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The password must contain at least one special character!'){
                                    this.alertMsg = i18n.t('resetPasswordInvalidCharacter')
                                }else{
                                    this.alertMsg =  i18n.t('serverError')
                                }
                            }
                        }else {
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }
                }
                this.buttonDisabled = false
                }
             }
        }
    }
}

</script>
